import React from "react"
import styled from 'styled-components'

const CategoryList = ({className, categories}) => {
    //console.log(categories.nodes)

    const categoryList = categories?.nodes?.map((item, i, arr) => {
        const comma = (arr.length - 1 === i) 
            ? ''
            : ','
            
        return (
            <div key={i} className="tag__item">
                <span>{item.name}{comma}</span>
            </div>
        )
    })

  return (
    <div className={className}>{categoryList}</div>
  )
}

const StyledCategoryList = styled(CategoryList)`
    .tag__item{
        display: inline-block;
        margin-right: 4px;
        position: relative;
        font-weight: 500;
        &:first-child {
            margin-left: 0;
            padding-left: 0;
        }
}

`

export default StyledCategoryList